export const PreviewDefaultSize = 1200;
